export const IPHONE_KEYS = ['amptheme', 'language']

export const SETTINGS_KEYS = [
  'review',
  'status',
  'layout',
  'language',
  'reviews',
  'analytics',
  'social',
  'menus',
  'customcss'
]

export const ALL_KEYS = ['amptheme', ...SETTINGS_KEYS]
